// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"1159c497","843":"013933ed","924":"f624c3bd"}[chunkId] + ".chunk.css";
};